export default function(x) {
  return (x * x * x * (35 / 3072));
}


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/proj4/lib/common/e3fn.js
// module id = null
// module chunks = 